import { render } from "./search_std.vue?vue&type=template&id=4580b6bb&scoped=true"
import script from "./search_std.vue?vue&type=script&lang=js"
export * from "./search_std.vue?vue&type=script&lang=js"

import "./search_std.vue?vue&type=style&index=0&id=4580b6bb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4580b6bb"]])

export default __exports__